import {Box} from '@mui/material';
import AppAnimate from 'main/core/AppAnimate';
import PropTypes from 'prop-types';
import {UiWiseActionType} from 'shared/constants/UiWiseConst';
import WidgetAction from '../WidgetAction';

const DocActions = ({actions, widgetData, onPrint, disabled}) => {
  return (
    <AppAnimate animation='transition.slideUpIn' delay={200}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1.5,
          width: '100%',
          // mx: (theme) => `-${theme.spacing(8)}`,
          // mt: (theme) => `-${theme.spacing(8)}`,
          mb: 5,
        }}
      >
        {actions?.map((action, i) => {
          const isPrintAction = action.actiontype === UiWiseActionType.PRINT;
          return (
            <WidgetAction
              key={i}
              action={action}
              data={widgetData}
              onClick={isPrintAction ? onPrint : undefined}
              disabled={isPrintAction ? disabled : undefined}
            />
          );
        })}
      </Box>
    </AppAnimate>
  );
};

DocActions.propTypes = {
  actions: PropTypes.array,
  widgetData: PropTypes.object,
  onPrint: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DocActions;
